// S-04 Connection, automatic PF security codes (task 25, D-82): the client-side checks and words.
import type { SecurityCodeResult } from '@pa/api/admin'

/** E.164, as the API checks it (`phone_invalid`): "+", a non-zero country digit, 8–15 digits in all. */
export const E164_RE = /^\+[1-9]\d{7,14}$/

/** The Telnyx inbound webhook path on our API (#73). */
export const WEBHOOK_PATH = '/v1/webhooks/telnyx/messages'

/** The full URL to paste into Telnyx's Messaging Profile, from the API origin the app talks to. */
export function webhookUrl(apiOrigin: string): string {
  return `${apiOrigin.replace(/\/+$/, '')}${WEBHOOK_PATH}`
}

/** The last code's result in words (never the code). */
export const RESULT_TEXT: Record<SecurityCodeResult, string> = {
  logged_in: 'Logged in',
  rejected: 'Rejected by Practice Fusion',
  expired: 'Expired before PF Keeper could use it',
  not_awaiting: 'Received; PF Keeper wasn’t waiting for a code yet',
  failed: 'Couldn’t reach PF Keeper',
  timeout: 'No code arrived in time; PF Keeper needs someone to log in',
}

export const securityCodeResultText = (r: SecurityCodeResult): string => RESULT_TEXT[r]
